module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel reports-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "reports-grid"
  }, [_vm._l((_vm.filteredGroups), function(group) {
    return (group.reports.length) ? _c('div', {
      key: group.name,
      staticClass: "report-group"
    }, [_c('div', {
      staticClass: "report-group-label"
    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _vm._l((group.reports), function(report, index) {
      return _c('div', {
        key: index,
        staticClass: "report-row",
        class: {
          'opacity-50 notAllowed': report.downloading
        },
        on: {
          "click": function($event) {
            return _vm.downloadReport(report)
          }
        }
      }, [_c('div', {
        staticClass: "file-badge",
        class: report.fileType
      }, [(report.downloading) ? _c('loader', {
        attrs: {
          "size": "small"
        }
      }) : _c('span', [_vm._v(_vm._s(report.fileType === 'pdf' ? 'PDF' : 'XLS'))])], 1), _vm._v(" "), _c('div', {
        staticClass: "report-info"
      }, [_c('span', {
        staticClass: "report-name"
      }, [_vm._v(_vm._s(report.name))]), _vm._v(" "), (report.subName) ? _c('span', {
        staticClass: "report-sub"
      }, [_vm._v(_vm._s(report.subName))]) : _vm._e(), _vm._v(" "), (report.downloading) ? _c('span', {
        staticClass: "report-status downloading"
      }, [_vm._v("Downloading…")]) : _vm._e(), _vm._v(" "), (report.downloadError) ? _c('span', {
        staticClass: "report-status error"
      }, [_vm._v("Error downloading")]) : _vm._e()])])
    })], 2) : _vm._e()
  }), _vm._v(" "), (!_vm.hasVisibleReports) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('span', [_vm._v("No reports available")])]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reports-head"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Reports Center")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-51617293", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51617293"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/reportsCenter.vue
// module id = 3022
// module chunks = 0